var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.promoData)?_c('div',{staticClass:"footer w-100 mb-4"},[_c('a',{attrs:{"target":"_blank","href":_vm.promoData.url}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.imageUrl(),"alt":""}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }